const qs                          = require('query-string');
const endpoint                    = require('@readcube/endpoint');
const SyncApi                     = require('@readcube/sync-api-web');
const { default: SyncUploader }   = require('@readcube/sync-uploader');
const AiPreview                   = require('../ai/ai_preview.js');
const guid                        = require('../util/guid');
const { version }                 = require('../../../package.json');
const {
  parseEnv,
  parseDoi,
  notifyParent
} = require('./helpers');

module.exports = function ai() {
  console.log(`%c ### AI PREVIEW, version: ${version}`, 'font-weight: bold; color: gold;');
  notifyParent('loaded');

  const env = parseEnv();
  const doi = parseDoi();

  const client    = { name: 'ai_preview', version, id: guid() };
  const syncApi   = SyncApi.create({ env, client, log: console });
  const uploader  = SyncUploader.create({ syncApi, log: console });

  endpoint.init(env);
  notifyParent('initialized');

  const query = qs.parse(location.search);
  const test = {
    force_upload: !!query.force_upload,
    skip_cache: !!query.skip_cache,
    skip_proxy: !!query.skip_proxy,
    ai_disabled: !!query.ai_disabled
  };

  const ai = new AiPreview({
    env,
    doi,
    syncApi,
    uploader,
    test
  });

  ai.evtout.on('author-search', (e, name, href) => {
    window.open(href, '_author_search');
  });
}
